import { render, staticRenderFns } from "./P012.vue?vue&type=template&id=6528e4ec"
import script from "./P012.vue?vue&type=script&lang=js"
export * from "./P012.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports